import { useMsal } from '@azure/msal-react';
import { getCurrentUserAccount } from '../lib/AccountSelection';

type CurrentUserHook = {
  fullName?: string;
  tenantId?: string;
  userId?: string /* this needs to go away when api is update to assert this from jtw */;
  userEmail?: string;
};

export function useCurrentUser(): CurrentUserHook {
  const { instance } = useMsal();

  const accountToUse = getCurrentUserAccount(instance);

  return {
    fullName: accountToUse?.name,
    tenantId: accountToUse?.idTokenClaims?.extension_TenantId as string,
    // sub = externalId
    userId: accountToUse?.idTokenClaims?.sub,
    // email
    userEmail: accountToUse?.idTokenClaims?.emails?.[0],
  };
}
